import { useTranslation } from "react-i18next"

const Loader = () => {
    const { t } = useTranslation();
    return (
        <div className="tngnt-fixed tngnt-inset-0 tngnt-bg-black tngnt-bg-opacity-50 tngnt-flex tngnt-justify-center tngnt-items-center tngnt-z-50">
            <div className="tangent_global_style tangent_global_style_custom tangent_loading_text_custom tangent_loading_text_mob_custom tngnt-bg-white tngnt-p-4 tngnt-rounded-lg tngnt-shadow-lg tngnt-flex tngnt-gap-6 tngnt-items-center">
                {t('Pleasewait')}...
                <span className="tngnt-relative tngnt-flex tngnt-h-3 tngnt-w-3">
                    <span className="tngnt-animate-ping tngnt-absolute tngnt-inline-flex tngnt-h-full tngnt-w-full tngnt-rounded-full tngnt-bg-blue-500 tngnt-opacity-75"></span>
                    <span className="tngnt-relative tngnt-inline-flex tngnt-rounded-full tngnt-h-3 tngnt-w-3 tngnt-bg-blue-500"></span>
                </span>
            </div>
        </div>
    )
}

export default Loader